(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerWrapper = this; // <sticky-header> element with .header-wrapper class
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      const customHeight = this.getAttribute('data-sticky-height');
      const height = customHeight && customHeight !== '0' ? `${customHeight}px` : `${this.header.offsetHeight}px`;
      document.documentElement.style.setProperty('--header-height', height);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      if (this.headerWrapper) {
        this.headerWrapper.classList.add('header-wrapper--hidden');
      }
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      if (this.headerWrapper) {
        this.headerWrapper.classList.remove('header-wrapper--hidden');
      }
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      if (this.headerWrapper) {
        this.headerWrapper.classList.remove('header-wrapper--hidden');
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Color scheme toggle on scroll
  (function() {
    const headerWrapper = document.querySelector('.header-wrapper');
    if (!headerWrapper) return;

    const primaryScheme = headerWrapper.getAttribute('data-primary-color-scheme');
    const secondaryScheme = headerWrapper.getAttribute('data-secondary-color-scheme');

    if (!primaryScheme || !secondaryScheme) return;

    const isGeneralPage = headerWrapper.hasAttribute('data-is-general-page');

    function updateColorScheme() {
      if (isGeneralPage) {
        // On general pages (e.g. /pages/xxx), always use secondary scheme
        headerWrapper.classList.remove(`color-${primaryScheme}`);
        headerWrapper.classList.add(`color-${secondaryScheme}`);
        headerWrapper.classList.add('scrolled-past-threshold');
        return;
      }

      // Apply secondary scheme when submenu/megamenu or menu drawer is open
      if (headerWrapper.classList.contains('menu-submenu-open') || headerWrapper.classList.contains('menu-drawer-open')) {
        headerWrapper.classList.remove(`color-${primaryScheme}`);
        headerWrapper.classList.add(`color-${secondaryScheme}`);
        headerWrapper.classList.add('scrolled-past-threshold');
        return;
      }

      const SCROLL_THRESHOLD = parseInt(headerWrapper.getAttribute('data-scroll-threshold')) || 64;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > SCROLL_THRESHOLD) {
        headerWrapper.classList.remove(`color-${primaryScheme}`);
        headerWrapper.classList.add(`color-${secondaryScheme}`);
        headerWrapper.classList.add('scrolled-past-threshold');
      } else {
        headerWrapper.classList.remove(`color-${secondaryScheme}`);
        headerWrapper.classList.add(`color-${primaryScheme}`);
        headerWrapper.classList.remove('scrolled-past-threshold');
      }
    }

    window.addEventListener('scroll', updateColorScheme, { passive: true });
    headerWrapper.addEventListener('headerMenuToggle', updateColorScheme);
    updateColorScheme(); // Check initial state
  })();

  } catch(e) { console.error(e); }
})();
})();
